import React from "react";
import {
  Breakpoint,
  Dialog,
  DialogContent,
  IconButton,
  styled,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface AnswerDialogProps {
  onClose: () => void;
  maxWidth?: false | Breakpoint;
  children: React.ReactNode;
}

const MoreContent = styled(DialogContent)({
  marginTop: 10,
  // lineHeight: 1.2,
});
const CloseMoreButton = styled(IconButton)({
  position: "absolute",
  top: 2,
  right: 2,
  zIndex: 400,
  "&:dir(rtl)": {
    right: "unset",
    left: 2,
  },
});

function AnswerDialog({ onClose, maxWidth, children }: AnswerDialogProps) {
  return (
    <Dialog
      open={true}
      scroll="paper"
      onClose={onClose}
      maxWidth={maxWidth}
      slotProps={{ root: { style: { zIndex: 1600 } } }} // to be on top of the tooltip
    >
      <CloseMoreButton onClick={onClose} size={"small"}>
        <CloseIcon />
      </CloseMoreButton>
      <MoreContent>{children}</MoreContent>
    </Dialog>
  );
}

export default AnswerDialog;
